import {Button} from "reactstrap";
import ChatAvatar from "../../../Components/ChatAvatar";
import get from "lodash/get";
import Moment from "react-moment";
import {LOGO_BY_TYPE} from "../../../Components/utils";
import {IonAvatar, IonIcon, IonItem, IonLabel, IonNote} from "@ionic/react";
import {volumeMute} from "ionicons/icons";
import React from "react";
import isEqual from "lodash/isEqual";
import {loadChats} from "../../../thunks/Chats";
import {
    clearChatFiltersKey,
    mergeChats,
    setActiveChat,
    setAllOldChatsLoaded,
    setChatFilters,
    setChats,
    setChatsVisibleLimit, updateChatFilters
} from "../../../actions/Chats";
import {getBlockedBotUsers} from "../../../thunks/Audience";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";

const trunc = (input_str, n) => (input_str.length > n) ? input_str.substr(0, n - 1) + '...' : input_str;


class ChatItem extends React.Component {
    constructor() {
        super();
        this.state = {
            searchInputValue: '',
            isMobile: true,
            loaderChatsScrollbar: true,
        };
    }


    componentDidMount() {

    }

    delay = (t, val) => {
        return new Promise((res) => {
            setTimeout(() => {
                res(val ? val : true);
            }, t);
        });
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    componentWillUnmount() {

    }


    render() {

        const activeChatId = parseInt(this.props.match.params.activeChatId);
        const now = new Date();
        const isActive = this.props.chat.id === activeChatId;
        const chatLink = `/${this.props.chat.shop_id}/chat/${this.props.chat.id}/`;

        const chatDate = new Date(this.props.chat.last_message_time * 1000);

        const button = <Button
            className="dropdown-item b-radius-0"
            color={isActive ? 'primary' : ''}
        >
            {
                (this.props.chat.last_message_time > this.props.chat.last_read_time && !isActive) && <div className="not-read">
                </div>
            }
            <div className="widget-content p-0">
                <div className="widget-content-wrapper">
                    <div className="widget-content-left mr-3">
                        <div className="avatar-icon-wrapper">
                            {/*<div className="badge badge-bottom badge-success badge-dot badge-dot-lg"/>*/}
                            <div className="avatar-icon" style={{background: '#dedede'}}>
                                <ChatAvatar chat={this.props.chat}/>
                            </div>
                        </div>
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading pr-5">
                            {this.props.chat.name}
                        </div>
                        <div className="widget-subheading pr-2">
                            {trunc(get(this.props.chat, 'last_message_text', '') || '', 30)}
                        </div>
                        <div className="widget-time text-secondary">

                            {this.props.chat.last_message_time && (
                                (now.getDate() === chatDate.getDate() && (now - chatDate) < 24 * 60 * 60 * 1000)
                                    ?
                                    <Moment locale='ru' format="HH:mm">{this.props.chat.last_message_time * 1000}</Moment>
                                    : <Moment locale='ru'
                                              format="DD/MM/YY">{this.props.chat.last_message_time * 1000}</Moment>)
                            }
                        </div>
                        <div className="widget-messenger">
                            <img className='img-fluid'
                                 src={LOGO_BY_TYPE[this.props.chat.bot?.bot_type]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Button>;


        return <IonItem routerLink={chatLink} key={this.props.chat.id} className="i-chats-list-item">
            <IonAvatar slot="start" className="i-chats-list-item-avatar">
                <ChatAvatar chat={this.props.chat}/>
            </IonAvatar>
            <IonLabel className="i-chats-list-item-label">
                <span className="i-chats-list-item-heading">{this.props.chat.name}</span>
                <div className="i-chats-list-item-subheading">
                    {trunc(get(this.props.chat, 'last_message_text', '') || '', 30)}
                </div>
            </IonLabel>
            <IonNote slot="end" className="i-chats-list-item-right">
                <div className={`i-chats-list-item-date ${(this.props.chat.last_message_time > this.props.chat.last_read_time && !isActive) ? 'i-chats-list-item-date-active' : ''}`}>
                    {this.props.chat.last_message_time && (
                        (now.getDate() === chatDate.getDate() && (now - chatDate) < 24 * 60 * 60 * 1000)
                            ?
                            <Moment locale='ru' format="HH:mm">{this.props.chat.last_message_time * 1000}</Moment>
                            : <Moment locale='ru'
                                      format="DD/MM/YY">{this.props.chat.last_message_time * 1000}</Moment>)
                    }
                </div>
                <div className="i-chats-list-item-right-icon">
                    {!!this.props.blockedBotUsersList?.filter(val => val.bot_user_id === this.props.chat.bot_user.id).length && <IonIcon icon={volumeMute} className="i-chats-list-item-right-icon-mute"/>}
                    {(this.props.chat.last_message_time > this.props.chat.last_read_time && !isActive) && <div className="i-chats-list-item-number_messages"></div>}
                </div>
            </IonNote>
        </IonItem>
    }


}


const mapDispatchToProps = dispatch => ({
    loadChats: (filters, callback) => dispatch(loadChats(filters, callback)),
    setChats: (chats) => dispatch(setChats(chats)),
    setActiveChat: (chat) => dispatch(setActiveChat(chat)),
    mergeChats: (chats) => dispatch(mergeChats(chats)),
    setChatsVisibleLimit: (limit) => dispatch(setChatsVisibleLimit(limit)),
    setAllOldChatsLoaded: (loaded) => dispatch(setAllOldChatsLoaded(loaded)),

    setChatFilters: (filters) => dispatch(setChatFilters(filters)),
    updateChatFilters: (filtersToUpdate) => dispatch(updateChatFilters(filtersToUpdate)),
    clearChatFiltersKey: (key) => dispatch(clearChatFiltersKey(key)),
    getBlockedBotUsers: () => dispatch(getBlockedBotUsers()),
});


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    wsConnected: state.Chats.wsConnected,
    chats: state.Chats.chats,
    chatsRequestSending: state.Chats.chatsRequestSending,
    chatsVisibleLimit: state.Chats.chatsVisibleLimit,
    allOldChatsLoaded: state.Chats.allOldChatsLoaded,
    chatFilters: state.Chats.chatFilters,
    activeBotUser: state.Audience.activeBotUser,

    blockedBotUsersList: state.Audience.blockedBotUsersList,
});

export default connect(mapStateToProps, mapDispatchToProps)(
    withRouter(withTranslation()(ChatItem))
);

